// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_format from "rescript/lib/es6/caml_format.js";
import * as AuthTokenHook$LiveRoom from "../../stores/AuthTokenHook.bs.js";

function createMe(authToken, paddleId) {
  return {
          paddleId: paddleId,
          authToken: authToken,
          transactional: typeof authToken === "object" && authToken.NAME === "Authenticated" ? authToken.VAL.details.userType === "transactional" : false
        };
}

function sessionStatus(me, enrollmentStatus) {
  var match = me.authToken;
  if (typeof match !== "object") {
    return /* NotLoggedIn */0;
  }
  if (match.NAME !== "Authenticated") {
    return /* NotLoggedIn */0;
  }
  if (!me.transactional) {
    AuthTokenHook$LiveRoom.isRevokedTransactionalUser(match.VAL);
    return /* AuthenticatedBasicUser */1;
  }
  var match$1 = me.paddleId;
  if (match$1 !== undefined) {
    return /* ApprovedToBid */{
            _0: match$1
          };
  } else if (enrollmentStatus !== undefined) {
    return /* RegistrationIncomplete */3;
  } else {
    return /* NotRegisteredToBid */2;
  }
}

function sessionStatusV2(me, enrollmentStatus) {
  var match = me.authToken;
  if (typeof match !== "object") {
    return /* NotLoggedIn */0;
  }
  if (match.NAME !== "Authenticated") {
    return /* NotLoggedIn */0;
  }
  if (!me.transactional) {
    AuthTokenHook$LiveRoom.isRevokedTransactionalUser(match.VAL);
    return /* AuthenticatedBasicUser */1;
  }
  if (enrollmentStatus === undefined) {
    return /* NotRegisteredToBid */2;
  }
  var variant = enrollmentStatus.NAME;
  if (variant === "EnrollmentUpForReview" || variant === "EnrollmentDeclined") {
    return /* RegistrationIncomplete */3;
  } else if (variant === "FutureAddedValue") {
    return /* NotRegisteredToBid */2;
  } else {
    return /* ApprovedToBid */{
            _0: Caml_format.int_of_string(enrollmentStatus.VAL.paddleId)
          };
  }
}

var HeaderAuctionFragment;

export {
  createMe ,
  sessionStatus ,
  HeaderAuctionFragment ,
  sessionStatusV2 ,
}
/* AuthTokenHook-LiveRoom Not a pure module */
